import { useEffect } from 'react';
import { Url } from '@wix/da-url';
import ddt from '@wix/da-ddt';
const logger = ddt.createLogger('useMessageListener');
export function useMessageListener(callback) {
    useEffect(()=>{
        const handler = (m)=>{
            const expectedOrigin = Url.origin();
            if (m.origin !== expectedOrigin) {
                logger.log('Invalid origin', m.origin);
                return;
            }
            callback && callback(m);
        };
        window.addEventListener('message', handler);
        return ()=>window.removeEventListener('message', handler);
    }, [
        callback
    ]);
}
